(function() {
  var SECTION_ID_PREFIX = 'sh-image-slider-section-';
  var RETRY_DELAYS = [0, 60, 180, 400];
  var resizeTimer = null;

  function applyCustomArrowSvg(sliderElement) {
    var prevArrow = sliderElement.querySelector('.splide__arrow--prev');
    var nextArrow = sliderElement.querySelector('.splide__arrow--next');
    var arrowSvgPrev = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    var arrowSvgNext = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

    if (prevArrow) prevArrow.innerHTML = arrowSvgPrev;
    if (nextArrow) nextArrow.innerHTML = arrowSvgNext;
  }

  function reapplyArrowsForAllSliders() {
    document.querySelectorAll('[id^="' + SECTION_ID_PREFIX + '"] .product-media-slider').forEach(function(sliderElement) {
      var instance = sliderElement.__shSplideInstance;
      if (instance && typeof instance.refresh === 'function') {
        instance.refresh();
      }

      // Apply immediately and once again after refresh/layout settles.
      applyCustomArrowSvg(sliderElement);
      window.setTimeout(function() {
        applyCustomArrowSvg(sliderElement);
      }, 120);
    });
  }

  function mountSliderInSection(sectionRoot) {
    if (!sectionRoot || !sectionRoot.id || sectionRoot.id.indexOf(SECTION_ID_PREFIX) !== 0) {
      return;
    }

    var sliderElement = sectionRoot.querySelector('.product-media-slider');
    if (!sliderElement || typeof window.Splide === 'undefined') {
      return;
    }

    if (sliderElement.__shSplideInstance && typeof sliderElement.__shSplideInstance.destroy === 'function') {
      sliderElement.__shSplideInstance.destroy(true);
    }

    var splide = new window.Splide(sliderElement, {
      rewind: true,
      perPage: 5,
      pagination: true,
      navigation: true,
      gap: 8,
      lazyLoad: 'nearby',
      preloadPages: 1,
      trimSpace: false,
      breakpoints: {
        1024: { perPage: 2 },
        768: {
          perPage: 1,
          padding: { right: '20%' }
        }
      },
      video: {
        loop: true,
        mute: true,
        autoplay: true
      }
    });

    splide.on('mounted updated resized', function() {
      applyCustomArrowSvg(sliderElement);
    });

    splide.mount(window.splide && window.splide.Extensions ? window.splide.Extensions : undefined);
    sliderElement.__shSplideInstance = splide;
  }

  function mountWithinNode(node) {
    if (!node) return;

    if (node.id && node.id.indexOf(SECTION_ID_PREFIX) === 0) {
      mountSliderInSection(node);
      return;
    }

    node.querySelectorAll('[id^="' + SECTION_ID_PREFIX + '"]').forEach(mountSliderInSection);
  }

  function scheduleMountWithinNode(node) {
    RETRY_DELAYS.forEach(function(delay) {
      window.setTimeout(function() {
        mountWithinNode(node || document);
      }, delay);
    });
  }

  function initAllShSliders() {
    mountWithinNode(document);
  }

  document.addEventListener('DOMContentLoaded', initAllShSliders);
  document.addEventListener('shopify:section:load', function(evt) {
    scheduleMountWithinNode(evt && evt.target ? evt.target : document);
  });
  document.addEventListener('shopify:section:select', function(evt) {
    scheduleMountWithinNode(evt && evt.target ? evt.target : document);
  });
  document.addEventListener('shopify:section:reorder', function(evt) {
    scheduleMountWithinNode(evt && evt.target ? evt.target : document);
  });
  window.addEventListener('resize', function() {
    if (resizeTimer) {
      window.clearTimeout(resizeTimer);
    }
    resizeTimer = window.setTimeout(reapplyArrowsForAllSliders, 120);
  });
})();
